import React from "react";

const VideoHero = () => {
  return (
    <>
      <section className="video-hero">
        {/* Background Video */}
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster="https://mgmotor.scene7.com/is/image/mgmotor/banner-img-001?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&wid=1920"
        >
          <source
            src="https://mgmotor.scene7.com/is/content/mgmotor/banner-vid-001-0x720-3000k"
            type="video/mp4"
            media="(min-width:991px)"
          />
          <source
            src="https://mgmotor.scene7.com/is/content/mgmotor/banner-vid-001-portrait-0x360-730k"
            type="video/mp4"
            media="(min-width:320px)"
          />
        </video>

        {/* Overlay */}
        <div className="overlay"></div>

        {/* Content */}
        <div className="hero-content">
          <img
            src="https://mgmotor.scene7.com/is/image/mgmotor/banner-logo-003?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=720"
            alt="MG Logo"
            className="hero-logo"
          />

          <button
  className="reserve-btn"
  onClick={() =>
    window.open(
      "https://www.mgmotor.co.in/vehicles/mg-majestor-biggest-suv-india/pre-reserve",
      "_blank"
    )
  }
>
  PRE - RESERVE
  <img
    src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='27' height='27' viewBox='0 0 27 27' fill='none'%3E%3Cpath d='M8.33398 8.56895L17.9978 8.33325M17.9978 8.33325L17.7621 17.997M17.9978 8.33325L8.56969 17.7613' stroke='currentColor' stroke-width='0.833333'/%3E%3C/svg%3E`}
    alt="arrow"
    className="btn-icon"
  />
</button>

        </div>
      </section>

      {/* Internal CSS */}
      <style>{`
        .video-hero {
          position: relative;
          width: 100%;
          height: 100vh;
          overflow: hidden;
        }

        .hero-video {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: translate(-50%, -50%);
          z-index: 1;
        }

        .overlay {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.45);
          z-index: 2;
        }

        .hero-content {
          position: relative;
          z-index: 3;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #fff;
          text-align: center;
          padding: 20px;
        }

        .hero-logo {
          width: 460px;
          margin-bottom: 20px;
        }

       

        .reserve-btn {
  padding: 14px 28px;
  border-radius: 8px;
  border: none;
  background: #ffffff;
  color: #000;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.reserve-btn:hover {
  background: #8c8888db;
  color: #000;
  border: 1px solid #fff;
}

.btn-icon {
  width: 18px;
  height: 18px;
}


        /* Responsive */
        @media (max-width: 991px) {
          .hero-content h1 {
            font-size: 48px;
          }

          .sub-text {
            font-size: 20px;
          }

          .hero-logo {
            width: 120px;
          }
        }

        @media (max-width: 576px) {
          .hero-content h1 {
            font-size: 34px;
          }

          .sub-text {
            font-size: 16px;
          }

          .reserve-btn {
            padding: 10px 20px;
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};

export default VideoHero;
